var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feed-item__title crop",style:({ background: _vm.backgroundColor })},[_c('h5',{staticClass:"text-center",class:_vm.textSizeClass},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }